import { atom } from 'jotai/index'
import { Member } from 'sierra-client/views/manage/programs/send-reminder/types'

export const selectedMembersAtom = atom<Member[]>([])

export const queryAtom = atom<string>('')

export const matchingMembersAtom = atom<(Member & { id: string })[]>([])
